import { render, staticRenderFns } from "./personalResume.vue?vue&type=template&id=0143c850&scoped=true&"
import script from "./personalResume.vue?vue&type=script&lang=js&"
export * from "./personalResume.vue?vue&type=script&lang=js&"
import style0 from "./personalResume.vue?vue&type=style&index=0&id=0143c850&scoped=true&lang=css&"
import style1 from "./personalResume.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143c850",
  null
  
)

export default component.exports